module.exports = __webpack_public_path__ + "img/daviplata.7c6a0b42.svg";